
export const common = {
  // Navigation
  nav: {
    home: 'Home',
    services: 'Services',
    aiSolutions: 'AI Solutions',
    bookDemo: 'Book Demo'
  },
  
  // Hero Section
  hero: {
    title: 'AI-Powered Marketing Excellence',
    subtitle: 'Optimieren Sie Ihr Unternehmen mit erstklassigen Marketingstrategien und modernsten Lösungen im Bereich der künstlichen Intelligenz, die messbare Ergebnisse liefern.',
    bookConsultation: 'Unser Marketingversprechen',
    exploreAI: 'Unsere KI Lösungen',
    skipIntro: 'Skip Intro'
  },
  
  // Services Section
  services: {
    title: 'Our Services',
    subtitle: 'Comprehensive AI-powered marketing solutions designed to accelerate your business growth and maximize your digital presence.',
    discussProject: 'Discuss Your Project',
    aiSeo: {
      title: 'AI-Powered SEO',
      description: 'Advanced search engine optimization using machine learning algorithms to predict and adapt to search engine changes.',
      features: [
        'Predictive keyword analysis',
        'Automated content optimization', 
        'Real-time ranking monitoring',
        'Competitor intelligence'
      ]
    },
    ppcManagement: {
      title: 'Intelligent PPC Management',
      description: 'Automated pay-per-click campaigns that optimize themselves in real-time for maximum conversion rates and ROI.',
      features: [
        'Smart bid optimization',
        'Dynamic ad creation',
        'Audience targeting AI',
        'Performance forecasting'
      ]
    },
    socialMedia: {
      title: 'Social Media Automation',
      description: 'AI-driven social media strategies that engage your audience with personalized content and optimal timing.',
      features: [
        'Content generation AI',
        'Engagement optimization',
        'Influencer matching',
        'Sentiment analysis'
      ]
    },
    emailMarketing: {
      title: 'Email Marketing AI',
      description: 'Personalized email campaigns powered by machine learning to increase open rates and conversions.',
      features: [
        'Behavioral targeting',
        'Send time optimization',
        'Subject line testing',
        'Churn prediction'
      ]
    },
    analytics: {
      title: 'Analytics & Insights',
      description: 'Deep data analysis and predictive insights that guide strategic decisions and forecast market trends.',
      features: [
        'Predictive analytics',
        'Customer journey mapping',
        'ROI optimization',
        'Market trend analysis'
      ]
    },
    chatbot: {
      title: 'AI Chatbot Development',
      description: 'Intelligent conversational AI that provides 24/7 customer support and lead qualification.',
      features: [
        'Natural language processing',
        'Lead qualification',
        'Multi-platform integration',
        'Learning algorithms'
      ]
    }
  },
  
  // AI Capabilities Section
  aiCapabilities: {
    title: 'AI Capabilities',
    subtitle: 'Mithilfe fortschrittlicher KI erzielen wir nachhaltige Marketingerfolge und messbare Ergebnisse.',
    learnMore: 'Learn More',
    readyTitle: 'Ready to Experience AI-Powered Marketing?',
    readySubtitle: 'Book a personalized demo to see how our AI solutions can transform your marketing strategy and accelerate your business growth.',
    bookDemo: 'Book Your Demo Now',
    machineLearning: {
      title: 'Machine Learning Optimization',
      description: 'Our algorithms continuously learn from your campaign data to improve performance automatically.',
      stats: ['95% accuracy improvement', 'Zukünftige Kostenreduktion', '24/7 optimization']
    },
    predictiveAnalytics: {
      title: 'Predictive Analytics',
      description: 'Forecast market trends and customer behavior to stay ahead of the competition.',
      stats: ['85% prediction accuracy', '3x faster insights', 'Real-time forecasting']
    },
    nlp: {
      title: 'Natural Language Processing',
      description: 'Advanced NLP capabilities for content creation, sentiment analysis, and customer communication.',
      stats: ['99% language accuracy', '50+ languages supported', 'Real-time processing']
    }
  },
  
  // Value Proposition Section
  valueProposition: {
    title: 'Why Choose BlecInk',
    subtitle: 'Wir kombinieren menschliche Kreativität mit künstlicher Intelligenz, um Marketinglösungen zu liefern, die nicht nur innovativ, sondern auch transformativ für Ihr Unternehmenswachstum sind.',
    readyTitle: 'Ready to Transform Your Marketing?',
    readySubtitle: 'Join over 500+ businesses that have revolutionized their growth with our AI-powered marketing solutions.',
    startTransformation: 'Start Your Transformation',
    aiFirst: {
      title: 'AI-First Approach',
      description: 'Leverage machine learning and artificial intelligence to optimize every aspect of your marketing campaigns for maximum ROI and performance.'
    },
    acceleratedGrowth: {
      title: 'Accelerated Growth',
      description: 'Our proven methodologies and AI-driven insights help businesses achieve 300% faster growth compared to traditional marketing approaches.'
    },
    guaranteedResults: {
      title: 'Guaranteed Results',
      description: 'We stand behind our work with performance guarantees and transparent reporting that shows exactly how your investment drives business growth.'
    }
  },
  
  // Contact Section
  contact: {
    title: 'Get Started',
    subtitle: 'Ready to transform your marketing with AI? Contact us today or book a personalized demo to see our solutions in action.',
    contactUs: 'Contact Us',
    bookDemo: 'Book Demo',
    fullName: 'Full Name',
    emailAddress: 'Email Address',
    companyName: 'Company Name',
    phoneNumber: 'Phone Number',
    message: 'Message',
    preferredDate: 'Preferred Date',
    preferredTime: 'Preferred Time',
    businessGoals: 'Business Goals & Challenges',
    sendMessage: 'Send Message',
    sending: 'Sending...',
    booking: 'Booking...',
    successContact: 'Thank you! We\'ll get back to you within 24 hours.',
    successDemo: 'Demo booked successfully! We\'ll send you a confirmation email shortly.',
    error: 'Something went wrong. Please try again.',
    placeholders: {
      fullName: 'Enter your full name',
      email: 'Enter your email',
      company: 'Enter your company name',
      phone: 'Enter your phone number',
      message: 'Tell us about your project and goals...',
      goals: 'Tell us about your current marketing challenges and what you hope to achieve...'
    },
    contactInfo: {
      email: 'Email Us',
      phone: 'Call Us',
      responseTime: 'Response Time',
      responseValue: '< 24 hours'
    }
  },
  
  // Footer
  footer: {
    description: 'Transforming businesses with AI-powered marketing solutions that deliver measurable results and accelerate growth in the digital landscape.',
    services: 'Services',
    company: 'Company',
    aboutUs: 'About Us',
    aiTechnology: 'AI Technology',
    contact: 'Contact',
    caseStudies: 'Case Studies',
    blog: 'Blog',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    poweredBy: 'Powered by Readdy',
    copyright: '© 2025 BlecInk. All rights reserved.'
  }
};
